import React from "react";
import { Link } from "react-router-dom";

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="mt-20 border-t border-slate-800/70 bg-slate-950/60"
  >
    <div className="mx-auto max-w-7xl px-4 py-10 sm:px-8">
      <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-center">
        <div>
          <div className="font-heading text-xl font-extrabold text-slate-50">
            Autopièce<span className="text-cyan-400"> Malin</span>
          </div>
          <p className="mt-1 max-w-md text-xs text-slate-500">
            Comparateur indépendant de pièces détachées auto, moto et poids lourd. Nous ne vendons
            aucune pièce : nous vous orientons vers les meilleurs fournisseurs via
            des liens d'affiliation transparents.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-6 text-xs text-slate-500 sm:grid-cols-3">
          <div>
            <div className="mb-2 font-mono uppercase tracking-widest text-slate-400">
              Produit
            </div>
            <Link
              to="/"
              data-testid="footer-link-home"
              className="block hover:text-cyan-400"
            >
              Accueil
            </Link>
            <Link
              to="/categories"
              data-testid="footer-link-categories"
              className="block hover:text-cyan-400"
            >
              Catégories
            </Link>
            <Link
              to="/contact"
              data-testid="footer-link-contact"
              className="block hover:text-cyan-400"
            >
              Contact
            </Link>
            <Link
              to="/blog"
              data-testid="footer-link-blog"
              className="block hover:text-cyan-400"
            >
              Blog
            </Link>
            <a href="/#how" className="block hover:text-cyan-400">
              Comment ça marche
            </a>
          </div>
          <div>
            <div className="mb-2 font-mono uppercase tracking-widest text-slate-400">
              Catégories
            </div>
            <Link to="/categories" className="block hover:text-cyan-400">
              Freinage
            </Link>
            <Link to="/categories" className="block hover:text-cyan-400">
              Filtration
            </Link>
            <Link to="/categories" className="block hover:text-cyan-400">
              Distribution
            </Link>
          </div>
          <div>
            <div className="mb-2 font-mono uppercase tracking-widest text-slate-400">
              Légal
            </div>
            <Link
              to="/mentions-legales"
              data-testid="footer-link-mentions"
              className="block hover:text-cyan-400"
            >
              Mentions légales
            </Link>
            <Link
              to="/politique-confidentialite"
              data-testid="footer-link-confidentialite"
              className="block hover:text-cyan-400"
            >
              Politique de confidentialité
            </Link>
            <Link
              to="/propriete-intellectuelle"
              data-testid="footer-link-propriete"
              className="block hover:text-cyan-400"
            >
              Propriété intellectuelle
            </Link>
          </div>
        </div>
      </div>
      <div className="mt-8 border-t border-slate-800/70 pt-6 font-mono text-[10px] uppercase tracking-widest text-slate-600">
        © 2026 Autopièce Malin · Service indépendant · Fait avec passion en France
      </div>
    </div>
  </footer>
);
